import { defineMessages } from 'react-intl';

export default defineMessages({
    continueText: {
        id: 'ml.agent.endorsement.pa.disclosureToQuote.We\'ll review your quote next',
        defaultMessage: 'We\'ll {reviewYourQuote} next!'
    },
    reviewYourQuote: {
        id: 'ml.agent.endorsement.pa.disclosureToQuote.review your quote',
        defaultMessage: 'review your quote'
    },
    confirmPremiumNextText: {
        id: 'ml.agent.endorsement.pa.disclosureToQuote.We\'ll confirm your premium and payment details next',
        defaultMessage: 'We\'ll {confirmPremium} next'
    },
    confirmPremium: {
        id: 'ml.agent.endorsement.pa.disclosureToQuote.confirm your premium and payment details',
        defaultMessage: 'confirm your premium and payment details'
    },
    orderMVRforHIDriverAgent: {
        id: 'ml.agent.endorsement.pa.disclosureToQuote.Hawaii MVRs return in approximately 2-3 days. When MVR is returned, you will be able to continue to the next screen.',
        defaultMessage: 'Hawaii MVRs return in approximately 2-3 days. When MVR is returned, you will be able to continue to the next screen.'     
    },
    premiumChangedDueToInfoReceivedAgent: {
        id: 'ml.agent.endorsement.pa.adjustments.We have received additional information which may have adjusted your premium.',
        defaultMessage: 'We have received additional information which may have adjusted your premium.'
    },
    ampSubsectionHeader: {
        id: 'ml.endorsement.wizard.step.pa.Information you entered or we received from consumer reports may have adjusted your premium.',
        defaultMessage: 'Information you entered or we received from consumer reports may have adjusted your premium.'
    },
    signNeededDescription: {
        id: 'ml.endorsement.common.adjustments.Well need you to sign your policy documents electronically next',
        defaultMessage: 'We\'ll need you to <strong>sign your policy documents electronically</strong> next'
    },
    signNotNeededDescription: {
        id: 'ml.endorsement.common.adjustments.Well confirm your policy changes next',
        defaultMessage: 'We\'ll <strong>confirm your policy changes</strong> next'
    },
    discloseExcludedDriverInfo: {
        id: 'ml.endorsement.wizard.step.pa.discloseExcludedDriverInfo',
        defaultMessage: 'This state requires entry of incident information for all rated and excluded drivers.'
    }
});